module.exports = __webpack_public_path__ + "static/media/fa-solid-900.813b8aee.woff2";